import { BfxBlotterAction } from "../bfx-base-blotter/BfxBlotterAction";
import { BfxBlotterContextMenuItem } from "../bfx-base-blotter/BfxBlotterContextMenuItem";

import { ContextMenuItemStateCommand } from "../ContextMenuItemStateCommand";
import { ContextMenuItemStateCommandCriteria } from "../ContextMenuItemStateCommandCriteria";


import { LoggerService } from "@bfx/logger";
const logger = LoggerService.for(__dirname);

import * as CubiqTS from "shared/cubiq-model-multi-asset";

export class BfxBlotterOrdersContextMenuItem extends BfxBlotterContextMenuItem<CubiqTS.OrderDataImpl> {
  constructor(
    public actionId: BfxBlotterAction,
    title: string,
    checkAvailable: ContextMenuItemStateCommand<CubiqTS.OrderDataImpl>,
    checkEnabled: ContextMenuItemStateCommand<CubiqTS.OrderDataImpl>,
    public checkAvailableCriteria: ContextMenuItemStateCommandCriteria = ContextMenuItemStateCommandCriteria.MenuItem,
    public checkEnabledCriteria: ContextMenuItemStateCommandCriteria = ContextMenuItemStateCommandCriteria.Item,
  ) {
    super(
      actionId,
      title,
      checkAvailable,
      checkEnabled,
      checkAvailableCriteria,
      checkEnabledCriteria,
    );
  }
}